import React from 'react';
import classnames from 'classnames';
import DumbView from '../../../../DeviationViews/Thumb/Shop';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Commission.scss';
const CommissionMonoReactView = ({ config: { alignment , link , width: configuredWidth  } , settings , deviation  })=>{
    let size = {
        width: 330,
        height: 340
    };
    // Handle resizing
    size = getSizeForFreeform(size, configuredWidth);
    if (settings && settings.showMediaAlwaysSmall) {
        size = {
            width: 212,
            height: 218
        };
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], s['normal'], alignment && s[alignment]),
        style: {
            width: size.width
        }
    }, /*#__PURE__*/ React.createElement(EditorDeviationLink, {
        link: link,
        deviation: deviation,
        linkClass: "gallery-link"
    }, /*#__PURE__*/ React.createElement(DumbView, {
        width: size.width,
        height: size.height,
        deviation: deviation
    })));
};
CommissionMonoReactView.displayName = 'CommissionMonoReactView';
export default CommissionMonoReactView;
